export const routesName = {
  home: '/',
  proytySuprotyv: '/proytySuprotyv',
  vpevnenist: '/vpevnenist',
}